const listeIngredient = [{
    ingredient: "Light rum"
}, {
    ingredient: "Applejack"
}, {
    ingredient: "Gin"
}, {
    ingredient: "Dark rum"
}, {
    ingredient: "Sweet Vermouth"
}, {
    ingredient: "Strawberry schnapps"
}, {
    ingredient: "Scotch"
}, {
    ingredient: "Apricot brandy"
}, {
    ingredient: "Triple sec"
}, {
    ingredient: "Southern Comfort"
}, {
    ingredient: "Orange bitters"
}, {
    ingredient: "Brandy"
}, {
    ingredient: "Lemon vodka"
}, {
    ingredient: "Blended whiskey"
}, {
    ingredient: "Dry Vermouth"
}, {
    ingredient: "Amaretto"
}, {
    ingredient: "Tea"
}, {
    ingredient: "Champagne"
}, {
    ingredient: "Coffee liqueur"
}, {
    ingredient: "Bourbon"
}, {
    ingredient: "Tequila"
}, {
    ingredient: "Vodka"
}, {
    ingredient: "A\u00f1ejo rum"
}, {
    ingredient: "Bitters"
}, {
    ingredient: "Sugar"
}, {
    ingredient: "Kahlua"
}, {
    ingredient: "demerara Sugar"
}, {
    ingredient: "Dubonnet Rouge"
}, {
    ingredient: "Lime juice"
}, {
    ingredient: "Irish whiskey"
}, {
    ingredient: "Apple brandy"
}, {
    ingredient: "Carbonated water"
}, {
    ingredient: "Cherry brandy"
}, {
    ingredient: "Creme de Cacao"
}, {
    ingredient: "Grenadine"
}, {
    ingredient: "Port"
}, {
    ingredient: "Coffee brandy"
}, {
    ingredient: "Red wine"
}, {
    ingredient: "Rum"
}, {
    ingredient: "Grapefruit juice"
}, {
    ingredient: "Ricard"
}, {
    ingredient: "Sherry"
}, {
    ingredient: "Cognac"
}, {
    ingredient: "Sloe gin"
}, {
    ingredient: "Apple juice"
}, {
    ingredient: "Pineapple juice"
}, {
    ingredient: "Lemon juice"
}, {
    ingredient: "Sugar syrup"
}, {
    ingredient: "Milk"
}, {
    ingredient: "Strawberries"
}, {
    ingredient: "Chocolate syrup"
}, {
    ingredient: "Yoghurt"
}, {
    ingredient: "Mango"
}, {
    ingredient: "Ginger"
}, {
    ingredient: "Lime"
}, {
    ingredient: "Cantaloupe"
}, {
    ingredient: "Berries"
}, {
    ingredient: "Grapes"
}, {
    ingredient: "Kiwi"
}, {
    ingredient: "Tomato juice"
}, {
    ingredient: "Cocoa powder"
}, {
    ingredient: "Chocolate"
}, {
    ingredient: "Heavy cream"
}, {
    ingredient: "Galliano"
}, {
    ingredient: "Peach Vodka"
}, {
    ingredient: "Ouzo"
}, {
    ingredient: "Coffee"
}, {
    ingredient: "Spiced rum"
}, {
    ingredient: "Water"
}, {
    ingredient: "Espresso"
}, {
    ingredient: "Angelica root"
}, {
    ingredient: "Orange"
}, {
    ingredient: "Cranberries"
}, {
    ingredient: "Johnnie Walker"
}, {
    ingredient: "Apple cider"
}, {
    ingredient: "Everclear"
}, {
    ingredient: "Cranberry juice"
}, {
    ingredient: "Egg yolk"
}, {
    ingredient: "Egg"
}, {
    ingredient: "Grape juice"
}, {
    ingredient: "Peach nectar"
}, {
    ingredient: "Lemon"
}, {
    ingredient: "Firewater"
}, {
    ingredient: "Lemonade"
}, {
    ingredient: "Lager"
}, {
    ingredient: "Whiskey"
}, {
    ingredient: "Absolut Citron"
}, {
    ingredient: "Pisco"
}, {
    ingredient: "Irish cream"
}, {
    ingredient: "Ale"
}, {
    ingredient: "Chocolate liqueur"
}, {
    ingredient: "Midori melon liqueur"
}, {
    ingredient: "Sambuca"
}, {
    ingredient: "Cider"
}, {
    ingredient: "Sprite"
}, {
    ingredient: "7-Up"
}, {
    ingredient: "Blackberry brandy"
}, {
    ingredient: "Peppermint schnapps"
}, {
    ingredient: "Creme de Cassis"
}, {
    ingredient: "Jack Daniels"
}];

export default listeIngredient;